// IconsCacheService.js

const DB_NAME = 'nodal-icons-cache';
const DB_VERSION = 1;
const STORE = 'snapshots';
const SNAPSHOT_KEY = 'iconsByKey.v1';

const canUseIndexedDb = () => typeof indexedDB !== 'undefined';

const openDb = () => {
  if (!canUseIndexedDb()) return Promise.resolve(null);

  return new Promise((resolve) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: 'id' });
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => resolve(null);
    request.onblocked = () => resolve(null);
  });
};

export const readIconsSnapshot = async () => {
  const db = await openDb();
  if (!db) return null;

  return new Promise((resolve) => {
    const tx = db.transaction(STORE, 'readonly');
    const store = tx.objectStore(STORE);
    const req = store.get(SNAPSHOT_KEY);

    req.onsuccess = () => {
      const value = req.result && typeof req.result.value === 'object' ? req.result.value : null;
      resolve(value);
    };

    req.onerror = () => resolve(null);

    tx.oncomplete = () => db.close();
    tx.onerror = () => {
      db.close();
      resolve(null);
    };
  });
};

export const writeIconsSnapshot = async (iconsByKey) => {
  const db = await openDb();
  if (!db) return false;

  return new Promise((resolve) => {
    const tx = db.transaction(STORE, 'readwrite');
    const store = tx.objectStore(STORE);

    store.put({
      id: SNAPSHOT_KEY,
      value: iconsByKey,
      ts: Date.now(),
    });

    tx.oncomplete = () => {
      db.close();
      resolve(true);
    };

    tx.onerror = () => {
      db.close();
      resolve(false);
    };
  });
};
